/**
 * SkinPicker — choose one of the seven skins (DEC-121 / 125 / 126 / 130).
 *
 * Opened from Settings › Interface. iPad-bound per DEC-096: mounted INSIDE
 * `.shell` via `shellPortal` and sized in `%`, never `vw`/`vh`. That is not
 * stylistic — `.shell` carries a `transform: scale()`, so a `position: fixed`
 * descendant fixes to the iPad frame and scales with it. A bare `<Portal>` on
 * a centred modal is the bug to catch in review.
 *
 * Each row previews the skin it selects using that skin's OWN tokens, by
 * putting `data-skin` on the row itself. So the swatch cannot drift from what
 * picking it does — the preview IS the skin, not a picture of it.
 */

import { For, Show } from 'solid-js';
import {
  SKINS, activeSkin, setActiveSkin,
} from '../settings/store.ts';

export default function SkinPicker() {
  // Navigate's Look (2026-10-05; the kit since 2026-10-06, app-study.html's
  // .skc): a card per skin, the PREVIEW drawn in the skin it selects (its own
  // canvas with rest / armed / live on it - the ground is half a skin's
  // identity), the name and line under it in Navigate's type. `skin` +
  // data-skin sit on the preview alone, so the card stays Navigate's.
  return (
    <section class="nv-ss" data-section="skin">
      <div class="nv-ss-h"><h2>Skin</h2><p>Dresses the stage. Navigate stays the same.</p></div>
      <div class="nv-skins" role="radiogroup" aria-label="Skin">
        <For each={SKINS}>
          {(skin) => (
            <button
              type="button"
              role="radio"
              class="nv-skin skinpicker-row"
              data-skin-id={skin.id}
              data-active={activeSkin() === skin.id ? 'true' : 'false'}
              aria-checked={activeSkin() === skin.id}
              onClick={() => setActiveSkin(skin.id)}
            >
              <span class="sk-skprev skin nv-skin-prev" data-skin={skin.id} aria-hidden="true">
                <i />
                <i data-s="armed" />
                <i data-s="live" />
              </span>
              <span class="nv-skin-meta">
                <b>
                  {skin.name}
                  <Show when={activeSkin() === skin.id}><span class="nv-ct nv-skin-on" data-s="live">In use</span></Show>
                </b>
                <small>{skin.blurb}</small>
              </span>
            </button>
          )}
        </For>
      </div>
    </section>
  );
}
